import React from "react";
import "./Flights2.css";
import img6 from "../images/img6.jpg";

const Flights2 = () => {
  return (
    <div className="flights2">
        <h2>Cross-Country Flight</h2>
      <div className="flights2-content">
        <div className="flights2-content1">
          <h3>FOR WHO?</h3>
          <p>
            There is no age limit. The maximum weight is 110 kilograms. A
            minimum level of physical fitness is required, as a short take-off
            run is needed at the start. If you’re unsure, feel free to contact
            us.
          </p>
          <h3>WHEN?</h3>
          <p>
            Between 1 PM and 5 PM, when weather conditions are favorable for the
            full flight duration.
          </p>
          <h3>KIND OF FLIGHT?</h3>
          <p>A high-altitude flight offering unforgettable panoramic views.</p>
          <p>
            And once you’re fully enjoying the flight, you’ll even have the
            chance to fly the paraglider yourself and/or discover some acrobatic
            figures.
          </p>
          <h3>What’s included?</h3>
          <p>
            Fees for takeoff and landing, insurance, and transportation to the
            takeoff site. Plus, complimentary full video and pictures of your
            flight sent directly to your mobile phone in less than 5 minutes, no
            internet required.
          </p>
        </div>
        <img src={img6} alt="" />
      </div>
    </div>
  );
};

export default Flights2;
